<template>
  <div>
    <PageHead title="党费报销申请"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">部门：</div>
              <a-tree-select
                allowClear
                v-model="form.organizationId"
                class="w200"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="请选择部门"
                tree-default-expand-all
                :replaceFields="{
                  key: 'id',
                  value: 'id',
                  children: 'treeList',
                  title: 'organizationName'
                }"
              >
              </a-tree-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">收款人：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入收款人"
                v-model="form.fullName"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">收款单位：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入收款单位"
                v-model="form.collectionCompanyName"
              />
            </div>
          </div>
          <blank height="20"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">表单状态：</div>
              <a-select
                allowClear
                class="w200"
                v-model="form.state"
                placeholder="请选择表单状态"
              >
                <template v-for="(item, index) in formStatusList">
                  <a-select-option :value="item.value" :key="index">
                    {{ item.label }}
                  </a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <a-button type="primary" @click="goDetial()" icon="plus">
          申请</a-button
        >
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :rowKey="(record) => record.id"
        :pagination="false"
        :columns="columns"
        :data-source="listData"
        :loading="loading"
      >
        <div slot="order" slot-scope="text, record, index">{{ index + 1 }}</div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>
          <template v-if="record.state == 0">
            <a-divider type="vertical" />
            <a-button type="link" class="btn-link" @click="goDetial(record)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="showDeleteConfirm(record)"
            >
              删除
            </a-button> </template
          ><a-divider type="vertical" v-if="record.recallButton" />
          <a-button
            v-if="record.recallButton"
            type="link"
            class="btn-link"
            @click="showRecallConfirm(record)"
          >
            撤回
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :size="size"
          :total="total"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'order',
    key: 'order',
    width: 80,
    scopedSlots: { customRender: 'order' }
  },
  {
    title: '部门/单位',
    dataIndex: 'departmentName',
    key: 'departmentName',
    ellipsis: true
  },
  {
    title: '收款人',
    dataIndex: 'collectionName',
    key: 'collectionName',
    ellipsis: true
  },
  {
    title: '收款单位名称',
    dataIndex: 'collectionCompanyName',
    key: 'collectionCompanyName',
    ellipsis: true
  },
  {
    title: '合计金额（元）',
    dataIndex: 'totalFee',
    key: 'totalFee',
    ellipsis: true
  },
  {
    title: '申请日期',
    dataIndex: 'applyTime',
    key: 'applyTime',
    ellipsis: true
  },
  {
    title: '表单状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: { customRender: 'state' },
    ellipsis: true
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 180,
    align: 'left'
  }
]
import { mapState, mapActions } from 'vuex'
import { expenseReimbursementList, deleteClaimExpense } from './api/api'
import { recallProcessFn } from '@/utils/utils'
export default {
  data() {
    return {
      listData: [],
      columns,
      form: {},
      page: 1,
      size: '10',
      total: 0,
      loading: false
      // formStatusList: this.$store.state.app.formStatusList
    }
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.treeData, // 组织机构树
      formStatusList: (state) => state.app.formStatusList // 表单状态
    })
  },
  created() {
    this.getorganizeListFn()
  },
  mounted() {
    this.expenseReimbursementListFn()
  },
  methods: {
    // 提交 未审批 可撤回流程
    showRecallConfirm(record) {
      const recallProcessPromise = new Promise((resolve, reject) => {
        recallProcessFn(
          this,
          record,
          resolve,
          reject,
          'expense-reimbursement-dues'
        )
      })
      recallProcessPromise
        .then((value) => {
          console.log(value)
          this.expenseReimbursementListFn()
        })
        .catch((error) => {
          console.log(error)
          this.expenseReimbursementListFn()
        })
    },
    ...mapActions(['getorganizeListFn']),
    // 拉取列表
    expenseReimbursementListFn() {
      this.loading = true
      const params = this.form
      params.page = this.page
      params.size = this.size

      expenseReimbursementList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.listData = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(item) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.deleteClaimExpenseFn(item.id)
        }
      })
    },
    deleteClaimExpenseFn(id) {
      deleteClaimExpense(id).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('删除成功')
          this.expenseReimbursementListFn()
        }
      })
    },

    goDetial(item, type) {
      if (type) {
        this.$router.push('/DuesClaimExpenseDetial?id=' + item.id + '&isEdit=1')
      } else {
        if (item) {
          this.$router.push('/DuesClaimExpenseDetial?id=' + item.id)
        } else {
          this.$router.push('/DuesClaimExpenseDetial')
        }
      }
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.expenseReimbursementListFn()
    },
    // 提交 查询
    subMit() {
      this.page = 1
      this.expenseReimbursementListFn()
    },
    cancel() {
      //取消
      this.form = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/DuesClaimExpense/index.vue